import * as Actions from '../actions';

const initialState = {
    monthlyData: null,
    rankingData: null,
};

const widgetsReducer = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.GET_MONTHLY_DATA:
            return {
                ...state,
                monthlyData: {...action.data}
            };
        case Actions.GET_RANKING_DATA:
            return {
                ...state,
                rankingData: {...action.data}
            };
        default:
            return state;
    }
};

export default widgetsReducer;


// WEBPACK FOOTER //
// ./src/main/content/analytics/store/reducers/widgets.reducer.js